/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Suffix_TipInputs */

const en_domain_search_modal_suffix_tip = /** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just the name, no .com needed (e.g. "janedoe" not "janedoe.com")`)
};

const es_domain_search_modal_suffix_tip = /** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo el nombre, no es necesario el .com (ej. 'janedoe' no 'janedoe.com')`)
};

const fr_domain_search_modal_suffix_tip = /** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste le nom, pas besoin de .com (ex. « janedoe » et non « janedoe.com »)`)
};

const de_domain_search_modal_suffix_tip = /** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur der Name, kein .com erforderlich (z.B. 'janedoe' nicht 'janedoe.com')`)
};

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const ja_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const zh_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const ar_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const id_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const it_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const ru_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const pt_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/** @type {(inputs: Domain_Search_Modal_Suffix_TipInputs) => LocalizedString} */
const ko_domain_search_modal_suffix_tip = en_domain_search_modal_suffix_tip;

/**
* | output |
* | --- |
* | "Just the name, no .com needed (e.g. \"janedoe\" not \"janedoe.com\")" |
*
* @param {Domain_Search_Modal_Suffix_TipInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_suffix_tip = /** @type {((inputs?: Domain_Search_Modal_Suffix_TipInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Suffix_TipInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_suffix_tip(inputs)
	if (locale === "es") return es_domain_search_modal_suffix_tip(inputs)
	if (locale === "fr") return fr_domain_search_modal_suffix_tip(inputs)
	if (locale === "de") return de_domain_search_modal_suffix_tip(inputs)
	if (locale === "ja") return ja_domain_search_modal_suffix_tip(inputs)
	if (locale === "zh") return zh_domain_search_modal_suffix_tip(inputs)
	if (locale === "ar") return ar_domain_search_modal_suffix_tip(inputs)
	if (locale === "id") return id_domain_search_modal_suffix_tip(inputs)
	if (locale === "it") return it_domain_search_modal_suffix_tip(inputs)
	if (locale === "ru") return ru_domain_search_modal_suffix_tip(inputs)
	if (locale === "pt") return pt_domain_search_modal_suffix_tip(inputs)
	return ko_domain_search_modal_suffix_tip(inputs)
});